import React from "react";
import { useNavigate } from "react-router-dom";
import "animate.css"; // Import animate.css for animations

const DonatePage = () => {
  const navigate = useNavigate();

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
      {/* Card for Donation Message */}
      <div className="card shadow-lg p-4 text-center animate__animated animate__fadeIn">
        <div className="card-body">
          <h2 className="text-success fw-bold mb-3 animate__animated animate__pulse animate__infinite">
            Support Our Platform ❤️
          </h2>
          <p className="text-dark fw-bold" style={{ fontSize: "1.1rem" }}>
            Your donation helps cover site costs and keeps us online. <br />
            <span className="text-primary fw-bold">G Pay / PhonePe: +91 99165 99713</span> <br />
            Mention subject as <span className="fw-bold">'TLI Nikah Portal'</span>.
          </p>
          
          {/* Donate Button */}
          <button 
            className="btn btn-warning btn-lg shadow-lg fw-bold mt-3 animate__animated animate__heartBeat animate__infinite" 
            style={{ width: "200px" }}
            onClick={() => navigate("/searchprofile")}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonatePage;
